module.exports = __webpack_public_path__ + "static/img/witness-teens-5.f03bf25e.png";